import _pt from 'prop-types';
import { useRef } from 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import _css from '@emotion/css';
import useAnnotationContext from "../../hooks/useAnnotationContext.js";
import ContextMenu from "./ContextMenu.js";

var AnnotationLayer = function AnnotationLayer(_ref) {
  var width = _ref.width,
      height = _ref.height,
      scale = _ref.scale,
      pageStore = _ref.pageStore;

  var _useAnnotationContext = useAnnotationContext(),
      handleMouseDown = _useAnnotationContext.handleMouseDown,
      handleMouseMove = _useAnnotationContext.handleMouseMove,
      handleMouseUp = _useAnnotationContext.handleMouseUp,
      handleClick = _useAnnotationContext.handleClick,
      Field = _useAnnotationContext.Field,
      cursorMode = _useAnnotationContext.cursorMode;

  var svgRef = useRef(null);
  return jsx("div", {
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    }
  }, jsx("svg", {
    ref: svgRef,
    width: width,
    height: height,
    style: {
      position: 'absolute',
      top: 0,
      left: 0
    },
    onMouseDown: function onMouseDown(e) {
      return handleMouseDown === null || handleMouseDown === void 0 ? void 0 : handleMouseDown(e, svgRef.current, pageStore);
    },
    onMouseMove: handleMouseMove,
    onMouseUp: handleMouseUp,
    onClick: handleClick
  }, jsx("g", {
    style: {
      transform: "scale(".concat(scale, ")")
    }
  }, jsx("rect", {
    width: width / scale,
    height: height / scale,
    fill: "#00000000",
    css: /*#__PURE__*/_css({
      cursor: cursorMode
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }), pageStore.fields.map(function (field) {
    return jsx(Field, {
      key: "".concat(field.x, "_").concat(field.y, "_").concat(field.width, "_").concat(field.height),
      field: field,
      selected: field === pageStore.pdfStore.selectedField
    });
  }))), pageStore.contextMenu && jsx(ContextMenu, {
    pageStore: pageStore
  }));
};

AnnotationLayer.displayName = "AnnotationLayer";
AnnotationLayer.propTypes = {
  width: _pt.number.isRequired,
  height: _pt.number.isRequired,
  scale: _pt.number.isRequired,
  children: _pt.node
};
var AnnotationLayer$1 = observer(AnnotationLayer);
export default AnnotationLayer$1;